import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetchHealthFacilities, loadingUser } from "../../action";
import DocumentViewDialog from "../../components/DocumentViewDailog/DocumentView";
import HealthFacilitiesDetails from "../../components/health/HealthFacilitiesDetails";
import Header from "../../Header";
import { useConvention } from "../../hooks/useConvention";
import { GedToken } from "../../utils/constant";

export default function HealthFacility() {
  const Content = styled("div")(({ theme }) => ({
    flexGrow: 1,
    paddingRight: theme.jrnlDrawer.close.width - theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  }));

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const userData = useSelector((state) => state.profileReducer);

  const token = localStorage.getItem("token");

  const SignInSuccess = useSelector((state) => state);

  const [documentView, setDocumentView] = useState(false);

  const [blobUrl, setBlobURL] = useState();

  const { isConventionnementActive } = useConvention();

  useEffect(() => {
    const loadUserData = async () => {
      await dispatch(loadingUser(token));
    };

    loadUserData().then(() => {
      const healthFacilityId =
        userData?.currentUserResponseData?.i_user?.health_facility_id;
      if (healthFacilityId) {
        dispatch(fetchHealthFacilities(healthFacilityId));
        //dispatch(fetchConventionnementByHFId(healthFacilityId))
      }
    });
  }, [
    dispatch,
    token,
    userData?.currentUserResponseData?.i_user?.health_facility_id,
  ]);

  // to view document
  const handleDocumnetView = (document) => {
    console.log("document", document);
    const apiUrl = `${process.env.REACT_APP_GED_URL}/documents/get`;
    const headers = {
      Authorization: `Bearer ${GedToken}`,
      "Content-Type": "application/json",
    };

    fetch(`${apiUrl}?documentUuid=${document?.documentId}`, {
      method: "POST",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const pdfUrl = URL.createObjectURL(blob);
        setBlobURL(pdfUrl);
        setDocumentView(true);
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };

  return (
    <Header
      navigate={{}}
      children={
        <Box>
          <Typography
            variant="h5"
            sx={{
              display: "flex",
              fontWeight: "bold",
              marginLeft: "20px",
            }}
          >
            {t("HealthFacilityDetails")}
          </Typography>
          <HealthFacilitiesDetails
            handleDocumnetView={handleDocumnetView}
          ></HealthFacilitiesDetails>
          {documentView && (
            <DocumentViewDialog
              blobUrl={blobUrl}
              documentView={documentView}
              setDocumentView={setDocumentView}
            />
          )}
        </Box>
      }
    />
  );
}
